import GetDemoController from './get-demo-controller';
import { compose } from "redux";
import { connect } from 'react-redux';
import { getValue } from "store/languages";
import { modalShowToggle } from "store/modal";
import { sendMessage, setIsDemoSuccess} from "store/landing";

let mapStateToProps = (state) => {
    return {
        isDemoSuccess: state.LandingMenu.isDemoSuccess
    }
}

const GetDemoContainer =  compose(
    connect(mapStateToProps, {
        getValue,
        modalShowToggle,
        sendMessage,
        setIsDemoSuccess
    }),
)(GetDemoController)

export default GetDemoContainer;